<template>
  <div class="container">
    <div class="right">
      <div class="flex-list">
        <div class="flex">
          <div>
            <el-input size="small" clearable placeholder="请输入流程功能名称" prefix-icon="el-icon-search" v-model="search.keyword"
              @clear="clearKeyword">
              <el-button slot="append" @click="flowsList" :disabled="!search.keyword">搜索</el-button>
            </el-input>
          </div>
        </div>
        <div>
          <el-button size="small" type="primary" icon="el-icon-plus" @click="showFlowDrawer = true">添加</el-button>
        </div>
      </div>
      <div class="distance">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="序号"></el-table-column>
          <el-table-column prop="name" label="流程功能"></el-table-column>
          <el-table-column prop="price" label="费用">
            <template slot-scope="scope">
              <el-tag size="small">{{ scope.row.price == '0.00' ? '面议' : scope.row.price }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="download_path" label="机器人流程">
            <template slot-scope="scope">
              <el-button @click="downloadFlow(scope.row.download_path)" class="size" type="primary" size="small"
                v-if="scope.row.download_path">
                下载流程文件
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" @change="statusChange(scope.row)" active-text="在售"
                inactive-text="下架" :active-value="1" :inactive-value="0">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip content="编辑" placement="top">
                <el-button @click="editFlow(scope.row)" class="size" type="text" size="small" icon="el-icon-edit-outline">
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagingVue :Pagination="Pagination" :tableData="tableData" @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange">
      </pagingVue>
    </div>

    <el-drawer :title="flowTitle" :visible.sync="showFlowDrawer" direction="rtl" @closed="flowDrawerClosed">
      <div style="padding: 16px;">
        <el-form ref="flow" :model="flow" :rules="flowRules" label-width="100px">
          <el-form-item label="流程功能" prop="name">
            <el-input v-model="flow.name" placeholder="请填写流程功能"></el-input>
          </el-form-item>
          <el-form-item label="流程描述" prop="desc">
            <el-input v-model="flow.desc" placeholder="请填写流程描述"></el-input>
          </el-form-item>
          <el-form-item label="流程开发者" prop="desc">
            <el-input v-model="flow.developer" placeholder="请填写流程开发者"></el-input>
          </el-form-item>
          <el-form-item label="流程分类" prop="flow_category_id">
            <el-select v-model="flow.flow_category_id" placeholder="请选择流程分类">
              <el-option v-for="item in flowCategories" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="流程标签" prop="flow_tags">
            <el-input v-model="flow.flow_tags" placeholder="请填写流程标签，多个用顿号(、)隔开"></el-input>
          </el-form-item>
          <el-form-item label="描述图" prop="desc_image">
            <el-upload :file-list="descImage" list-type="picture" :limit="1" :on-exceed="descImageExceed"
              accept=".jpeg,.png,.jpg" :action="uploadUrl" :headers="uploadHeaders" :on-success="uploadDescImgSuccess" :on-error="uploadError">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png/jpeg文件，且不超过2M</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="费用" prop="price">
            <el-input v-model="flow.price" type="number"></el-input>
          </el-form-item>
          <el-form-item label="流程文件" prop="download_path">
            <el-upload :file-list="downloadPathList" list-type="text" :limit="1" :on-exceed="descImageExceed"
              accept=".flow" :action="uploadUrl" :headers="uploadHeaders" :on-success="uploadDownloadPathSuccess" :on-error="uploadError">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传flow文件，且不超过10M</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-switch v-model="flow.status" active-text="在售" inactive-text="下架" :active-value="1" :inactive-value="0">
            </el-switch>
          </el-form-item>
          <el-form-item label="更多描述" prop="more_desc">
            <quill-editor v-model="flow.more_desc" ref="myQuillEditor" :options="editorOption">
            </quill-editor>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitFlow">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import pagingVue from "../../../components/Paging/paging.vue";
import { baseURL } from "@/api/request";
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
  name: "Ait_flow_list",
  data() {
    return {
      showFlowDrawer: false,
      flowTitle: "添加流程配置",
      flowCategories: [],
      editorOption: {},
      search: {
        keyword: "",
        page: "",
      },
      Pagination: {},
      tableData: [],
      flow: {},
      descImage: [],
      downloadPathList: [],
      uploadUrl: baseURL + "admin/upload-oss-file",
      uploadHeaders: {
        method: "POST",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      flowRules: {
        name: [{ required: true }],
        desc: [{ required: true }],
        flow_category_id: [{ required: true }],
        desc_image: [{ required: true }],
      }
    };
  },
  components: {
    pagingVue,
    quillEditor
  },
  mounted() {
    this.flowCategoriesList();
    this.flowsList();
  },
  methods: {
    clearKeyword() {
      this.flowsList();
    },
    async flowCategoriesList() {
      await this.$axios
        .getListData("admin/ait-flow-categories")
        .then((res) => {
          if (res.code === 200) {
            this.flowCategories = res.data
          }
        });
    },
    async flowsList() {
      await this.$axios
        .getListData("admin/ait-flows", this.search)
        .then((res) => {
          if (res.code === 200) {
            this.Pagination = res.data.meta.pagination;
            let flowData = res.data.data;
            this.tableData = flowData.map((v) => {
              return {
                ...v,
                created_at: this.$inserted(v.created_at),
              };
            });
          }
        });
    },
    // 分页
    handleSizeChange(val) {
      this.Pagination.per_page = val;
    },
    handleCurrentChange(val) {
      this.search.page = val;
      this.flowsList();
    },
    downloadFlow(path) {
      // 前端浏览器下载
      this.$confirm("下载机器人流程文件?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        window.location.href = path;
      }).catch(() => {});
    },
    statusChange(row) {
      // 修改状态
      this.$axios.postListData('admin/update-ait-flow', row);
    },
    editFlow(row) {
      this.showFlowDrawer = true;
      this.flow = row;
      this.descImage = [{
        name: row.desc_image.split('/').pop(),
        url: row.desc_image
      }];
      this.downloadPathList = [{
        name: row.download_path.split('/').pop(),
        url: row.download_path
      }];
    },
    submitFlow() {
      this.$refs['flow'].validate((valid) => {
        if (valid) {
          let postFlowUrl = this.flow.id ? 'admin/update-ait-flow' : 'admin/ait-flows';
          this.$axios.postListData(postFlowUrl, this.flow)
            .then((res) => {
              if (res.code === 200) {
                this.showFlowDrawer = false;
                this.flow = {};
                this.descImage = [];
                this.downloadPathList = [];
                this.flowsList();
              }
            });
        } else {
          return false;
        }
      })
    },
    descImageExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件,本次选择了 ${files.length
        } 个文件,共选择了 ${files.length + fileList.length} 个文件`
      )
    },
    flowDrawerClosed() {
      this.flow = {};
      this.descImage = [];
      this.downloadPathList = [];
      this.flowsList();
    },
    uploadDescImgSuccess(res) {
      this.flow.desc_image = res.data.fullpath;
    },
    uploadDownloadPathSuccess(res) {
      this.flow.download_path = res.data.fullpath;
    },
    uploadError(err) {
      this.$message.error('文件上传失败');
    }
  },
};
</script>
<style lang="less" scoped>
/deep/.cell {
  max-height: 28px !important;
}

/deep/.el-table__empty-text {
  line-height: 53px;
}

/deep/.el-table__empty-block {
  min-height: 53px;
}

/deep/.el-dialog__body {
  padding: 20px;
}

/deep/.el-dialog__headerbtn .el-dialog__close {
  color: #909399;
  display: none;
}

/deep/.el-message-box__headerbtn .el-message-box__close {
  display: none;
  color: #909399;
}

/deep/.el-button--text {
  font-size: 18px;
  margin-top: -8px;
}

/deep/.el-table__body {
  width: 100% !important;
}

/deep/.el-select {
  width: 100% !important;
}

/deep/.el-form-item {
  margin-bottom: 12px;
}

/deep/.el-radio-group {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.dialog-footer {
  display: flex !important;
  justify-content: space-around !important;
}

.container {
  width: 100%;
  box-sizing: border-box;
  padding: 30px;
  overflow: hidden;

  .right-item {
    margin: 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .distance {
    margin: 10px 0;
  }

  .right {
    .flex-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .flex {
      display: flex;
      align-items: center;
    }
  }

  /deep/.el-dialog__body {
    padding: 20px !important;
  }
}
</style>
  